<nav class="navbar navbar-default blue-bg">
    <div class="container container-fluid">
        <div class="navbar-header">
            <h1 class="navbar-brand">Wybór wniosku</h1>
        </div>
    </div>
</nav>
<br/>

<div class="grid">
    <div class="w-full md:wp-8 align-items-center justify-content-center flex flex-direction-column">
        <ul class="list-none p-1 m-0 w-full">
            <li class="flex align-items-center py-3 px-2 surface-border flex-wrap">
                <div class="text-500 w-6 md:wp-2 font-medium">Typ rejestru</div>
                <div class="text-900 w-full md:wp-10">
                    <p-radioButton name="registers" value="RPK" label="Rejestr pośredników kredytu konsumenckiego (RPK)" [(ngModel)]="preDocument.registerTypeId"></p-radioButton>
                </div>
            </li>
            <li class="flex align-items-center py-3 px-2 border-top-1 surface-border flex-wrap">
                <div class="text-500 w-6 md:wp-2 font-medium">Rodzaj wniosku</div>
                <div class="text-900 w-full md:wp-10">
                    <p-radioButton name="types"  value="REGISTRATION" label="Wpis" [(ngModel)]="preDocument.documentTypeId"></p-radioButton>&nbsp;
                </div>
            </li>

            <li class="flex align-items-center py-3 px-2 border-top-1 surface-border flex-wrap">
                <div class="text-500 w-6 md:wp-2 font-medium">Forma prawna&nbsp;</div>
                <div class="text-900 w-full md:wp-10">
                    <p-radioButton name="entities" value="OF_P_1" styleClass="margin-top-bottom" label="Osoba fizyczna" [(ngModel)]="preDocument.companyTypeId" (onClick)="preDocument.companyId=undefined"></p-radioButton>&nbsp;
                    <p-radioButton name="entities" value="O_PR_1" styleClass="margin-top-bottom" label="Osoba prawna / Spółka nieposiadająca osobowości prawnej" [(ngModel)]="preDocument.companyTypeId" (onClick)="preDocument.companyId=undefined"></p-radioButton>&nbsp;
                </div>
            </li>
            <form #chooseForm="ngForm">
                <li class="flex align-items-center py-3 px-2 border-top-1 surface-border flex-wrap" *ngIf="preDocument.companyTypeId=='OF_P_1'">
                    <div class="text-500 w-6 md:wp-2 font-medium">NIP</div>
                    <div class="text-900 w-full md:w-5">
                        <p-inputMask inputId="inputmask" mask="9999999999" autocomplete="off" placeholder="__________" [(ngModel)]="preDocument.companyId" [unmask]=true [autoClear]=false [minlength]="10" nipValidator [required]="true" #nip="ngModel" name="nip"></p-inputMask>
                        <small *ngIf="nip.invalid && (nip.dirty || nip.touched)" class="p-error">
                            <div *ngIf="nip?.errors?.['required']">
                                Numer NIP jest wymagany
                            </div>
                            <div *ngIf="nip?.errors?.['minlength']">
                                Numer NIP musi składać się z 10 cyfr
                            </div>
                            <div *ngIf="nip.errors?.['nip']">
                                Niepoprawny numer NIP
                            </div>
                        </small>
                    </div>
                </li>
                <li class="flex align-items-center py-3 px-2 border-top-1 surface-border flex-wrap" *ngIf="preDocument.companyTypeId && preDocument.companyTypeId!='OF_P_1'">
                    <div class="text-500 w-6 md:wp-2 font-medium">KRS</div>
                    <div class="text-900 w-full md:w-5">
                        <p-inputMask inputId="inputmask" mask="9999999999" autocomplete="off" [autoClear]=false [minlength]="10" placeholder="__________" [(ngModel)]="preDocument.companyId" [unmask]=true [required]="true" #krs="ngModel" name="krs"></p-inputMask>
                        <small *ngIf="krs.invalid && (krs.dirty || krs.touched)" class="p-error">
                            <div *ngIf="krs?.errors?.['required']">
                                Numer KRS jest wymagany
                            </div>
                            <div *ngIf="krs?.errors?.['minlength']">
                                Numer KRS musi składać się z 10 cyfr
                            </div>
                        </small>
                    </div>
                </li>
            </form>
        </ul>
        <p-button label="Utwórz wniosek" icon="pi" class="justify-content-center" (click)="createForm()"></p-button>&nbsp;
    </div>

    <div class="w-full md:wp-1 hidden md:visible">
        <p-divider layout="vertical">
            <strong>LUB</strong>
        </p-divider>
    </div>
    <div class="w-full md:wp-1 visible md:hidden">
        <p-divider align="center" layout="horizontal">
            <strong>LUB</strong>
        </p-divider>
    </div>
    <div class="w-full md:wp-3 col-5 flex align-items-center justify-content-center">
        <p-button label="Lista wniosków do podpisu" icon="pi" (click)="showProposalsList()"></p-button>&nbsp;
    </div>
</div>

<p-blockUI [blocked]="blockUI">
    <p-progressSpinner></p-progressSpinner>
</p-blockUI>

